





























import Vue from 'vue';
import BravadoButtonV3 from '~/components/common/BravadoButtonV3/BravadoButtonV3.vue';

export default Vue.extend({
  name: 'ErrorLayout',
  components: { BravadoButtonV3 },
  layout: 'clear',
  props: {
    error: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isProd: process.env.isProduction,
    };
  },
});
